import React from 'react'

const Chip = ({onClick, text, largeFont, label, color, className, outlined} ) => {
    let styles = ''

    if(!color) color = 'primary'

    if(text) {
        styles = `bg-zinc-50 text-black ${outlined = 'outline outline-none'}`
    }

  return (
    <div className={`md:mt-0 pt-0 md:pt-0  align-middle  ${className}`}>
        <button  className={`rounded-full mx-5 px-2 h-[45px] md:h-[45px] lg:h-[45px] flex items-center justify-center ${styles} `} onClick={() => {onClick()}}>
            <span className={`cursor-pointer font-roboto font-semibold ${largeFont ? 'text-[1rem]' : 'text-xs'}`}>
                {label}
            </span>
        </button>
    </div>
  )
}

export default Chip